// src/pages/Dashboard.js
import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import ProfileEditor from '../components/ProfileEditor';
import QuotesList from '../components/QuotesList';
import './Dashboard.css'; // Vamos criar este arquivo de estilo

const Dashboard = () => {
    const { currentUser, userProfile } = useAuth();
    const [activeTab, setActiveTab] = useState('quotes'); // 'profile' ou 'quotes'

    if (!currentUser || !userProfile) {
        return <div className="container">Carregando...</div>;
    }

    return (
        <div className="dashboard-page">
            <div className="container">
                <div className="dashboard-header">
                    <h1>Meu Painel</h1>
                    <p>Olá, {userProfile.nome || currentUser.email}! Bem-vindo(a) de volta.</p>
                </div>

                <div className="dashboard-content">
                    <div className="dashboard-nav">
                        <button 
                            className={activeTab === 'quotes' ? 'active' : ''}
                            onClick={() => setActiveTab('quotes')}
                        >
                            Minhas Cotações
                        </button>
                        <button 
                            className={activeTab === 'profile' ? 'active' : ''}
                            onClick={() => setActiveTab('profile')}
                        >
                            Meus Dados
                        </button>
                    </div>

                    <div className="dashboard-tab-content">
                        {activeTab === 'profile' && <ProfileEditor />}
                        {activeTab === 'quotes' && <QuotesList />}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;